import { useApi } from "../api/useApi";
import { AuditItem, UserAccount } from "../types";
import { useAccountState } from "../../redux/reducers/accountReducer";

export const AuditHistoryApiRoutes = {
    getCaseAuditHistory: (accountId: string, caseId: string) => `account/${accountId}/case/${caseId}/auditHistory`,
    getAccountAuditHistory: (accountId: string) => `account/${accountId}/auditHistory`,
}

export type AuditHistoryService = {
    getCaseAuditHistoryAsync: (accountId: string, caseId: string) => Promise<AuditItem[] | undefined>;
    getAccountAuditHistoryAsync: (accountId: string) => Promise<AuditItem[] | undefined>;
}
/**
 * This service will load expenses for a specific case and provides methods to interact with them
 * @param caseId 
 * @param autoload
 * @returns
 */
export const useAuditHistoryService = (caseId?: string): AuditHistoryService => {

    //Hooks
    const { primaryAccount } = useAccountState();
    const { account } = primaryAccount as UserAccount ?? {};

    //Api
    const api = useApi<AuditItem>('api/AuditHistory');

    //Data Calls
    const getCaseAuditHistoryAsync = async (myCaseId?: string) => {
        return await api.getAsync(
            AuditHistoryApiRoutes.getCaseAuditHistory(account?.accountId as string, myCaseId || (caseId as string)),
        );
    };

    const getAccountAuditHistoryAsync = async () => {
        return await api.getAsync(
            AuditHistoryApiRoutes.getAccountAuditHistory(account?.accountId as string),
        );
    };
       
    return {
        getCaseAuditHistoryAsync,
        getAccountAuditHistoryAsync,
    }
}
